import { message, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import moment from "moment";

class DarDeBajaActivo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    unidad: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarUnidad();
    }
  }

  consultarUnidad() {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/datosUnidadActivoFijo",
        { entradaSalidaId: this.props.entradaSalidaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status !== 404) {
          this.setState({ unidad: res.data.unidad });
        }
      });
  }

  cerrarDarDeBajaActivo(codigo) {
    this.props.cerrarDarDeBajaActivo(codigo);
    if (this.formRef.current) this.formRef.current.resetFields();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/darDeBajaActivo",
        {
          ...values,
          entradaSalidaId: this.props.entradaSalidaId,
          empresaId: this.props.empresaId,
          fecha: values.fecha || moment(),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha dado de baja el activo");
          this.cerrarDarDeBajaActivo(res.data.polizaId);
        } else {
          message.error(res.data.message || "Hubo un error y no se pudo dar de baja");
        }
      });
  }

  render() {
    const valorEnLibros = this.state.unidad?.valorEnLibros || 0;
    return (
      <ModalItem
        title="Dar de Baja Activo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarDarDeBajaActivo.bind(this)}
        paddingTop
        width={600}
      >
        <Alert
          style={{ marginBottom: 12 }}
          type={valorEnLibros > 0 ? "warning" : "info"}
          message={
            valorEnLibros > 0
              ? `Se cargará ${dineroDisabledMask(valorEnLibros)} a la cuenta de Pérdida de Activo (valor en libros aún no depreciado).`
              : "Este activo ya está completamente depreciado, no se generará pérdida."
          }
        />
        <Form
          ref={this.formRef}
          name="darDeBajaActivo"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
              Dar de Baja
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="fecha" label="Fecha de Baja" margin initialValue={moment()} tooltip={{ title: "Fecha en la que se registra contablemente la baja." }}>
            <DatePickerItem style={{ width: "100%" }} format="DD/MM/YYYY" />
          </FormItem>
          <FormItem name="motivoBaja" label="Motivo" required margin pattern tooltip={{ title: "Usa 'Dar de Baja' cuando NO hay venta (desecho, siniestro, donación, obsolescencia). Si sí hubo venta, usa 'Vender Activo' en su lugar." }}>
            <TextAreaItem placeholder="Ej. Equipo dañado, obsoleto, donado, siniestro" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(DarDeBajaActivo);
